import React from 'react';
import { PagesCarousel } from '../ui/PagesCarousel';
import { SectionLabel } from '../ui/SectionLabel';
export function PagesPreview() {
  return <section aria-labelledby="paginas-title" className="w-full bg-ink-850" data-id="element-153" data-mp="1j1lqkunae6ct">
      <div className="mx-auto grid max-w-5xl items-center gap-10 px-5 py-16 md:grid-cols-[1fr_auto] md:gap-14 md:py-20" data-id="element-154" data-mp="1nvg2hbwnhh1c">
        <div className="max-w-xl" data-id="element-155" data-mp="1ruys2kzf2gai">
          <SectionLabel data-id="element-156" data-mp="v5r312zl9p1u">Mire por dentro</SectionLabel>
          <h2 id="paginas-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-157" data-mp="v7bwsqe2x3yn">
            Páginas reales del método, tal como las va a recibir
          </h2>
          <p className="mt-4 text-base leading-relaxed text-body" data-id="element-158" data-mp="1958w3ujx3oh0">
            Listas de chequeo, tablas y protocolos en formato A4, listos para usar. Pase las páginas
            y vea el nivel de detalle.
          </p>
          <p className="mt-5 text-sm text-subtle" data-id="element-159" data-mp="2kjw3q594heua">
            📄 +250 páginas · 🖨️ Formato A4 · 📲 Se lee desde cualquier dispositivo
          </p>
        </div>
        <PagesCarousel data-id="element-160" data-mp="jzcpzcfctlst" />
      </div>
    </section>;
}